<script>
import {VueMaskDirective as mask} from 'v-mask'
import service from '../../../../domain/leiloes/services'
import * as Status from '../../../../domain/leiloes/helpers/LoteStatus'
import BtnStatus from './BtnStatus.vue'
import BtnStatusConfirmar from './ConfirmStatus'
import ACL from '../../../../domain/acl/tmp-acl'
import {mapGetters} from 'vuex'
import PopupViewer from '../../../_default/components/popup-viewer/PopupViewer'
import {isArray} from 'lodash'
import GerenciamentoEntidadeLote from './gerenciamento-lote-entidade/GerenciamentoEntidadeLote'
import GerenciamentoLoteDebito from './gerenciamento-lote-debitos/GerenciamentoLoteDebito'
import GerenciamentoLoteRestricoes from './gerenciamento-lote-restricoes/GerenciamentoLoteRestricoes'
import {StatusTitle as RetiradaStatusTitle} from '../../../../domain/grv/helpers/retirada-status'

export default {
  components: {
    GerenciamentoLoteRestricoes,
    GerenciamentoLoteDebito,
    GerenciamentoEntidadeLote,
    PopupViewer,
    BtnStatus,
    BtnStatusConfirmar,
    DadosConsultaLoteDetro: () => import('./DadosConsultaLoteDetro'),
    ExtratoLeilaoForm: () => import('./ExtratoLeilaoForm'),
    FormularioRetirada: () => import('../../retirada/components/addRetirada'),
    FormularioAlterarArrematante: () => import('./FormularioAlterarArrematante')
  },
  nome: 'lote',
  directives: {mask},
  data () {
    return {
      lote: null,
      isUploadingFoto: false,
      lances: null,
      lancesLoading: false,
      videoDestaque: '',
      showDadosConsultaLote: false,
      showFormExtratoLeilao: false,
      showFormRetirada: false,
      showFormAlterarArrematante: false,
      extratoCadastrado: false,
      STATUS_RETIRADO: 10,
      estadoLote: {
        value: null,
        label: null,
        parents: []
      },
      urlGrv: ''
    }
  },
  computed: {
    getStatus () {
      const status = Status.Status
      if (ACL.check('adm_alterar_status_lote', this.currentUser.id)) return status
      const currentStatus = status[this.lote.status]
      return Object.fromEntries(Object.entries(status).filter(([key, value]) => (value.onlyAdm === false || value === currentStatus)))
    },
    getEstadosLote (v) {
      return Status.ESTADOS_LOTE
    },
    comissao () {
      let comissao = Number(this.lote.leilao.comissao)
      let valorArremate = Number(this.lote.valorArremate)
      return valorArremate * (comissao / 100)
    },
    porcentagemAvaliacao () {
      let tabelaFipe = typeof this.lote.valorTabelaFipe !== 'undefined' ? this.lote.valorTabelaFipe : 0
      let avaliacao = typeof this.lote.valorAvaliacao !== 'undefined' ? this.lote.valorAvaliacao : 0
      if (tabelaFipe > 0 && avaliacao > 0) {
        return this.round((avaliacao / tabelaFipe) * 100, 2)
      }
      return 0
    },
    porcentagemMinimo () {
      let tabelaFipe = typeof this.lote.valorTabelaFipe !== 'undefined' ? this.lote.valorTabelaFipe : 0
      let minimo = typeof this.lote.valorMinimo !== 'undefined' ? this.lote.valorMinimo : 0
      if (tabelaFipe > 0 && minimo > 0) {
        return this.round((minimo / tabelaFipe) * 100, 2)
      }
      return 0
    },
    ACL () {
      return ACL
    },
    datesDiffInDays () {
      let date1 = new Date()
      let date2 = new Date(this.lote.grv.data.date)
      const MILLISECONDS_IN_A_DAY = (1000 * 60 * 60 * 24)

      date1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate())
      date2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate())

      return Math.floor(date2 - date1) / MILLISECONDS_IN_A_DAY
    },
    ...mapGetters(['isLogged', 'currentUser'])
  },
  mounted () {
    window.addEventListener('resize', this.init)
  },
  activated () {
  },
  created () {
    this.load()
    console.log(typeof Status.Status)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.init)
  },
  deactivated () {
    this.$destroy() // no keep-alive
  },
  watch: {},
  methods: {
    load () {
      this.$loaderOverlay.open().message('Aguarde enquanto carregamos o lote')
      service.findLote(this.$route.params.leilao, this.$route.params.id)
          .then((response) => {
            this.$loaderOverlay.hide()
            this.lote = response.data
            if (this.lote.estadoLote) this.estadoLote = Status.ESTADOS_LOTE.find(e => e.value === this.lote.estadoLote.id)
            if (this.lote.grv) {
              if (this.lote.grv.tipoProcesso === 1) {
                this.urlGrv = 'roubo-furto.visualizar.patio'
              } else {
                this.urlGrv = 'grv.visualizar.patio'
              }
            }
            this.videoDestaque = this.lote.videoDestaque
            this.init()
            this.carregaLances()
            console.log(this.lote)
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            console.log(response)
          })
    },
    init () {
      this.$nextTick(() => {
        let tableLancesHead = this.$el.querySelector('#tableLancesHead')
        let tableLancesBody = this.$el.querySelector('#tableLances')
        console.log(tableLancesBody.clientWidth, tableLancesHead.clientWidth)
        tableLancesHead.style.width = tableLancesBody.clientWidth + 'px'
      })
    },
    carregaLances () {
      this.lancesLoading = true
      service.getLoteLances(this.lote.leilao.id, this.lote.id)
          .then((response) => {
            this.lancesLoading = false
            this.lances = response.data.lances
            console.log(this.lances)
          })
          .catch((error) => {
            this.lancesLoading = false
            alert('Não foi possível carregar os lances')
            console.log(error)
          })
    },
    round: function (number, precision) {
      let factor = Math.pow(10, precision)
      let tempNumber = number * factor
      let roundedTempNumber = Math.round(tempNumber)
      return roundedTempNumber / factor
    },
    print: function () {
      window.print()
    },
    HelperCondicao (v) {
      return Status.Condicao[v]
    },
    Status () {
      return Status
    },
    confirmarAlteracaoStatus (v) {
      let estadoLote = this.estadoLote.value
      this.$refs.confirmarStatus.open(v, this.lote.status, estadoLote, (newStatus, newEstadoLote) => {
        let oldStatus = this.lote.status
        this.lote.status = newStatus
        this.setEstadoGeral(newEstadoLote)
        service.atualizaStatusLote(this.lote.leilao.id, this.lote.id, newStatus, newEstadoLote.value)
            .then((response) => {
              // nothing to do
            })
            .catch((response) => {
              window.alert(response.data.errors)
              this.lote.status = oldStatus
              console.log(response)
            })
      })
    },
    setEstadoGeral (v) {
      if (typeof v !== 'undefined') {
        console.log(v)
        this.estadoLote = v
      }
    },
    adjustFirstLetter (v) {
      return v.charAt(0).toLowerCase() + v.slice(1)
    },
    defineFotoDestaque (id, fotoIndex) {
        // Not work: https://stackoverflow.com/questions/42807888/vuejs-and-vue-set-update-array
      this.lote.fotos[fotoIndex].atualizandoDestaque = true
      service.setFotoDestaque(this.lote.leilao.id, this.lote.id, id)
          .then((response) => {
            delete this.lote.fotos[fotoIndex].atualizandoDestaque
            for (let foto in this.lote.fotos) {
              this.lote.fotos[foto].destaque = this.lote.fotos[foto].id === id
            }
          })
          .catch((response) => {
            delete this.lote.fotos[fotoIndex].atualizandoDestaque
            window.alert('Não foi possível atualizar a imagem para destaque, algum problema ocorreu, tente novamente.')
            console.log(response)
          })
    },
    uploadFotoLote: async function (e) {
      this.isUploadingFoto = true
      const {files} = e.target
      for (let foto of files) {
        try {
          let formData = new FormData()
          formData.append('file', foto, foto.name)
          const response = await service.uploadFotoLote(this.lote.leilao.id, this.lote.id, formData)
            // this.isUploadingFoto = false
          this.lote.fotos = response.data
          console.log(response)
        } catch (error) {
            // this.isUploadingFoto = false
          window.alert(`Não foi possível fazer o upload da foto ${foto.name} do lote, algum problema ocorreu, tente novamente.`)
          console.log(error)
        }
      }
      this.isUploadingFoto = false
    },
    removeFoto (id) {
      if (!confirm('Excluir esta foto?')) return
        // let nodeFoto = this.$el.querySelector('#ltFoto' + id)
        // nodeFoto.classList.add('hide')
        // let parent = nodeFoto.parentNode
      service.deleteFotoLote(this.lote.leilao.id, this.lote.id, id)
          .then((response) => {
            // parent.removeChild(nodeFoto)
            console.log(response)
            const index = this.lote.fotos.findIndex(item => item.id === id)
            this.lote.fotos.splice(index, 1)
          })
          .catch((response) => {
            window.alert('Não foi possível deletar a foto do lote, algum problema ocorreu, tente novamente.')
            // nodeFoto.classList.remove('hide')
            console.log(response)
          })
    },
    atualizaDestaque () {
      service.atualizaDestaque(this.lote.leilao.id, this.lote.id, this.lote.destaque)
          .then((response) => {
            console.log(response)
          })
          .catch((response) => {
            window.alert('Não foi possível atualizar o destaque, algum problema ocorreu, tente novamente.')
            this.lote.destaque = !this.lote.destaque
            console.log(response)
          })
    },
    editar () {
      this.$router.push({name: 'lotes.editar', params: {id: this.lote.id}})
    },
    salvarVideo () {
      let videos = this.videoDestaque
      service.updateVideoDestaque(this.lote.id, videos)
          .then((response) => {
            alert('Video atualizado com sucesso')
          })
          .catch((response) => {
            alert('Erro ao atualizar o vídeo')
          })
    },
    deletarLance (id) {
      var r = confirm('Tem certeza que deseja deletar este lance?')
      if (r) {
        var motivo = prompt('Informe o motivo que levou a deletar este lance:')
        this.$loaderOverlay.open().message('Deletando lance...')
        service.deleteLance(id, motivo)
            .then((response) => {
              this.$loaderOverlay.hide()
              alert('Lance deletado com sucesso')
              this.carregaLances()
            })
            .catch((response) => {
              this.$loaderOverlay.hide()
              alert('Erro ao deletar o lance')
              alert(response.data.errors)
              console.log(response)
            })
      }
    },
    deletarTodosLances (id) {
      const resposta = confirm('Tem certeza que deseja deletar todos os lances deste lote?')
      if (!resposta) return
      const motivo = prompt('Informe o motivo que levou a deletar todos os lances:')
      this.$loaderOverlay.open().message('Deletando lances...')
      service.deleteAllLances(id, motivo)
        .then((response) => {
          this.$loaderOverlay.hide()
          alert('Lances deletados com sucesso')
          this.carregaLances()
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          alert('Erro ao deletar o lance')
          alert(response.data.errors)
          console.log(response)
        })
    },
    openDadosConsultaLote () {
      this.showDadosConsultaLote = true
    },
    closeDadosConsulta () {
      this.showDadosConsultaLote = false
    },
    cadastrarVistoria () {
      if (!this.lote.situacaoVeiculo) {
        alert('É necessário informar a situação do veículo.\n Clique no botão EDITAR e atualize os dados deste lote.')
        return
      }
      if (confirm('Confirmar cadastrar vistoria deste lote?')) {
        this.$loaderOverlay.open('Cadastrando vistoria...')
        service.cadastrarVistoria(this.$route.params.id)
            .then(response => {
              this.$loaderOverlay.hide()
              alert('Vistoria cadastrada com sucesso.')
              this.lote.vistoriaCadastrada = response.data.vistoriaCadastrada
            })
            .catch(error => {
              this.$loaderOverlay.hide()
              alert(this.printError(error.data.errors))
            })
      }
    },
    executarConsultaLoteDetro () {
      if (confirm('Executar consulta DETRO para este lote?')) {
        this.$loaderOverlay.open('Cadastrando vistoria...')
        service.executarConsultaDadosLote(this.$route.params.id)
            .then(response => {
              this.$loaderOverlay.hide()
              this.$refs.gerenciamentoEntidadeLote.carregarEntidadesLote()
              this.$refs.gerenciamentoLoteDebito.carregarDebitosLote()
              this.$refs.gerenciamentoLoteRestricoes.carregarRestricoesLote()
              alert('Consulta realizada com sucesso.')
            })
            .catch(error => {
              this.$loaderOverlay.hide()
              alert(this.printError(error.data.errors))
            })
      }
      this.$forceUpdate()
    },
    openFormExtratoLeilao () {
      if (!this.lote.grv) {
        alert('Este lote não está relacionado a uma GRV.\n Clique no botão Editar e adicione a GRV correspondente')
        return
      }
      this.showFormExtratoLeilao = true
    },
    closeFormExtratoLeilao () {
      this.showFormExtratoLeilao = false
    },
    setExtratoCadastrado () {
      this.extratoCadastrado = true
    },
    openFormRetirada () {
      this.showFormRetirada = true
    },
    closeFormRetirada (teste = null) {
      if (teste) {
        this.lote.grv.retirada.status = teste
      }
      this.showFormRetirada = false
    },
    printError (err) {
      if (isArray(err)) {
        return err[0]
      }
      return err
    },
    RetiradaStatusTitle (s, t) {
      return RetiradaStatusTitle(s, t)
    },
    openFormAlterarArrematante () {
      this.showFormAlterarArrematante = true
    },
    closeFormAlterarArrematante (reloadPage = false) {
      if (reloadPage) {
        this.load()
      }
      this.showFormAlterarArrematante = false
    }
  }
}
</script>

<template>
  <transition name="slide">
    <div v-if="lote !== null" class="content-transition">
      <btn-status-confirmar :Status="getStatus" :EstadosLote="getEstadosLote" ref="confirmarStatus"></btn-status-confirmar>
      <div class="fade-in-down">
        <div class="bg-light lter b-b wrapper-md">
          <div class="row">
            <div class="col-md-6">
              <img width="150" src="../assets/lote-retirado.jpg" class="pull-left m-r" v-if="lote.status === STATUS_RETIRADO">
              <img :src="lote.fotoDestaque && lote.fotoDestaque.min" width="150" class="pull-left m-r" v-else>
              <h1 class="m-n font-thin h3">Lote #{{ lote.numero }}</h1>
              <router-link v-if="lote.grv" :to="{name: urlGrv, params: {id: lote.grv.id}}" target="_blank" replace>
                <h2 class="m-n font-thin h3">
                  GRV: <u :style="`color: ${lote.grv && lote.grv.bloqueadoParaLeilao ? 'red' : '#3103d0'}`">{{lote.grv && lote.grv.numero}}</u>
                  <span class="text-danger" v-if="lote.grv && lote.grv.bloqueadoParaLeilao">(GRV bloqueada para leilão)</span>
                </h2>
              </router-link>
              <p class="">{{ lote.titulo || '' }}</p>
              <span class="label no-radius bg-dark">{{ lote.tipo ? lote.tipo.nome : '' }}</span>
              <span class="label m-l-n-xxs no-radius bg-success ">{{ lote.marca ? lote.marca.nome : '' }}</span>
              <!--<span class="label m-l-n-xxs no-radius bg-white ">{{ lote.comitente.pessoa.nome }}</span>-->
            </div>
            <div class="col-md-6">
              <div class="row">
                <div class="visible-xs m-t-lg"></div>
                <u-button class="btn btn-sm btn-info pull-right pull-none-xs hidden-print  m-r-sm" tabindex="1"
                          @click.prevent="print">Imprimir
                </u-button>
                <u-button class="btn btn-sm btn-default pull-right pull-none-xs m-r-sm hidden-print" tabindex="1"
                          @click.prevent="editar">
                  Editar
                </u-button>
                <btn-status v-if="ACL.check('alterar_status_lote', currentUser.id)" :Status="getStatus" :value="lote.status" @input="confirmarAlteracaoStatus"
                            class="pull-right pull-none-xs m-r-sm hidden-print"></btn-status>
                <router-link :to="{name: 'leiloes.visualizar', params: {id: lote.leilao.id}}"
                            class="pull-right pull-none-xs hidden-print m-t-xs m-r"
                            style="clear: left"><strong class="label no-radius bg-info">Voltar</strong> para a tela do
                  leilão
                </router-link>
              </div>
              <div class="row m-t-sm" >
                <h3 id="estado-geral-title">{{estadoLote.label || "--"}}&nbsp;<span class="label label-sm m-r-xs" :class="'bg-' + getStatus[lote.status].class">&nbsp;</span></h3>
              </div>
            </div>
          </div>
        </div>
        <div class="wrapper-md">
          <div v-if="lote.arremate" class="alert alert-info">
            Lote arrematado por <a href="javascript:void(0)">{{ lote.arremate.arrematante.pessoa.nome }}</a>
            ({{ lote.arremate.arrematante.apelido }}),
            {{ adjustFirstLetter(moment(lote.arremate.dataArremate.date).format('LLLL'))
            }}, por <strong>R$ {{ lote.valorArremate | moeda }}</strong>.
            <br>
            Situação: <strong>{{ Status().StatusArremate[lote.arremate.status] }}</strong>
          </div>
          <div class="wrapper-sm bg-white m-b" v-if="lote.comitente">
            <img :src="lote.comitente.imagem" width="100" class="m-r">
            {{ lote.comitente.pessoa.nome }}
          </div>
          <div class="wrapper-sm bg-white m-b" v-else>
            Lote sem comitente
          </div>
          <GerenciamentoEntidadeLote ref="gerenciamentoEntidadeLote"/>
          <GerenciamentoLoteDebito ref="gerenciamentoLoteDebito"/>
          <GerenciamentoLoteRestricoes ref="gerenciamentoLoteRestricoes"/>
          <div class="wrapper-sm no-padder m-b">
            <div class=" bg-black">
              <div class="wrapper-sm bg-dark font-bold text-uppercase">Lances</div>
              <div class="bg-black pos-rlt" id="tableLancesHead">
                <table class="table table-black bg-black m-b-none">
                  <thead>
                  <tr>
                    <th style="width: 25%">Data</th>
                    <th style="width: 25%">Apelido</th>
                    <th style="width: 25%">Valor</th>
                    <th style="width: 25%"></th>
                  </tr>
                  </thead>
                </table>
              </div>
              <div class="scroll-black scroll-lote">
                <table class="table table-black" id="tableLances" style="margin-top: -36px">
                  <thead>
                  <tr>
                    <th style="width: 25%">Data</th>
                    <th style="width: 25%">Apelido</th>
                    <th style="width: 25%">Valor</th>
                    <th style="width: 25%"></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(lance, key) in lances">
                    <td>{{ moment(lance.data.date).format('L') }} {{ moment(lance.data.date).format('LTS') }}</td>
                    <td>
                      <router-link target="_blank"
                                   :to="{name: 'arrematante.visualizar', params: {id: lance.arrematanteId}}">{{
                        lance.apelido }}
                      </router-link>
                       <span style="color: gray" v-if="key === 0 && lote.arremate">&nbsp;(Boleta <span style="font-size:14px">{{lote.arremate.boleta}}</span>)</span>
                    </td>
                    <td>R$ {{ lance.valor | moeda }}</td>
                    <th><a v-if="ACL.check('deletar_lance', currentUser.id)" @click="deletarLance(lance.id)" class="text-danger" style="color:#ff6362">Deletar</a></th>
                  </tr>
                  <tr v-if="(!lances || lances.length === 0) && !lancesLoading">
                    <td colspan="4" class="no-borders" style="border-bottom: none"><span class="text-danger">Nenhum lance</span>
                    </td>
                  </tr>
                  <tr v-if="lancesLoading">
                    <td colspan="4" class="no-borders text-center" style="border-bottom: none"><i
                      class="fa fa-spin fa-spinner m-t fa-2x"></i></td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
          <a v-if="ACL.check('deletar_lance', currentUser.id)" @click="deletarTodosLances(lote.id)" class="btn btn-danger m-b">Deletar todos os lances</a>
          <u-button v-if="ACL.check('deletar_lance', currentUser.id)" @click="openFormAlterarArrematante" class="btn btn-danger m-b" :disabled="!lote.arremate || lote.status !== 6">Alterar arrematante</u-button>
          <u-button class="btn btn-md btn-info pull-right pull-none-xs m-r-sm hidden-print" tabindex="1"
                    @click.prevent="cadastrarVistoria" v-if="!lote.vistoriaCadastrada">
            Cadastrar vistoria do lote
          </u-button>
          <u-button class="btn btn-md btn-success pull-right pull-none-xs m-r-sm hidden-print" tabindex="1"
                    @click.prevent="openFormExtratoLeilao" v-else-if="lote.status === Status().STATUS_VENDIDO && !lote.extratoLeilao && !extratoCadastrado">
            Cadastrar extrato de leilão
          </u-button>
          <u-button class="btn btn-md btn-success pull-right pull-none-xs m-r-sm hidden-print" tabindex="1"
                    @click.prevent="openFormExtratoLeilao" v-if="!!lote.extratoLeilao || extratoCadastrado">
            <i class="fa fa-check"></i> Extrato já cadastrado para este lote
          </u-button>
          <u-button class="btn btn-md btn-info pull-right pull-none-xs hidden-print m-r-sm" tabindex="1"
                    @click.prevent="openDadosConsultaLote">Ver dados de consulta
          </u-button>
          <u-button class="btn btn-md btn-info pull-right pull-none-xs hidden-print m-r-sm" tabindex="1"
                    @click.prevent="executarConsultaLoteDetro">Executar consulta de dados DETRO
          </u-button>
          <div class="row">
            <div class="col-xs-12 col-md-8">
              <p>
                ID: <strong>{{ lote.id }}</strong> <br>
                Número: <strong>{{ lote.numero }}</strong> <br>
                Interno: <strong>{{ lote.syncId }}</strong> {{ lote.syncExtra }}<br>
                GRV: <strong :class="{'text-danger': lote.grv && lote.grv.bloqueadoParaLeilao}">{{ lote.grv && lote.grv.numero || '-' }}</strong> <span class="text-danger" v-if="lote.grv && lote.grv.bloqueadoParaLeilao">(GRV bloqueada para leilão)</span> {{ lote.syncExtra }}<br>
                Condição: <strong>{{ Status().Condicao[lote.condicao] }}</strong> <br>
                Acessórios: <strong>{{ lote.acessorios }}</strong> <br><br>
                Tipo de bem: <strong>{{ lote.tipo ? lote.tipo.nome : '' }}</strong><br>
                Marca: <strong>{{ lote.marca ? lote.marca.nome : '' }}</strong><br>
              </p>
              <div v-if="lote.modelo">
                Modelo: <strong>{{ lote.modelo.modelo ? lote.modelo.modelo.nome : '' }}</strong><br>
                Fabricação: <strong>{{ lote.modelo.anoFabricacao }}</strong><br>
                Ano: <strong>{{ lote.modelo.anoModelo }}</strong><br><br>
              </div>
              <p v-if="lote.grv && lote.grv.retirada">
                Informações de retirada: <br>
                <strong>Veículo possui retirada com status {{RetiradaStatusTitle(lote.grv && lote.grv.retirada.status).toUpperCase()}}</strong><br>
                <u-button class="btn btn-sm btn-success pull-none-xs hidden-print m-r-sm" tabindex="1"
                          @click.prevent="openFormRetirada" v-if="ACL.check('temp_alterar_retirada_lote', currentUser.id)">Atualizar Retirada
                </u-button>
              </p>
              <p>
                Informações adicionais:<br>
              </p>
              <div v-for="tipoValor in lote.tipoCampos">
                {{ tipoValor.tipo.nome }}: <strong>{{ tipoValor.valor }}</strong><br>
              </div>
              <br>
              <p>
                Observações:<br><br>
                {{ lote.observacao }}
              </p>

              <div class="wrapper-sm b b-2x">
                <div class="m-b"><strong>Configurações para o site</strong></div>
                <div>
                  <p>Apelido para URL amígável: <strong><a class="hover-items">{{ lote.slug }} <i
                    class="fa fa-edit show-hover"></i></a></strong></p>
                  <p>URL pública: <strong><a
                    :href="'https://www.consorciorioparkingcarioca.com/lote/' + lote.id + '/' + lote.slug"
                    target="_blank">{{ 'https://www.consorciorioparkingcarioca.com/lote/' + lote.id + '/' + lote.slug
                    }}</a></strong></p>
                  <p>Destaque: <span class="visible-print-inline-block">{{ lote.destaque ? 'Sim' : 'Não' }}</span>
                    <u-button-group @change="atualizaDestaque" class="hidden-print" v-model="lote.destaque"
                                    :options="[{label: 'Sim', value: true, class: 'btn-success'},{label: 'Não', value: false, class: 'btn-danger'}]"></u-button-group>
                  </p>

                  Vídeos:
                  <div class="row">
                    <div class="col-sm-6"><input class="form-control" v-model="videoDestaque"/></div>
                    <div class="col-sm-6">
                      <button class="btn btn-success inline" @click="salvarVideo">Salvar</button>
                    </div>
                  </div>
                  para mais de um vídeo, separe-os por ,

                </div>
              </div>

            </div>
            <div class="col-xs-12 col-md-4 text-right">

              <table class="table table-condensed">
                <tbody>
                <tr>
                  <td>% FIPE - Avaliação:</td>
                  <td><strong>{{ porcentagemAvaliacao }}%</strong></td>
                </tr>
                <tr>
                  <td>Valor Avaliação:</td>
                  <td><strong>R$ {{ lote.valorAvaliacao | moeda }} {{ porcentagemAvaliacao }}%</strong></td>
                </tr>
                <tr>
                  <td>% FIPE - Mínimo:</td>
                  <td><strong>{{ porcentagemMinimo }}%</strong></td>
                </tr>
                <tr>
                  <td>Valor Mínimo:</td>
                  <td><strong>R$ {{ lote.valorMinimo | moeda }}</strong></td>
                </tr>
                <tr>
                  <td>Valor Tabela Fipe:</td>
                  <td><strong>R$ {{ lote.valorTabelaFipe | moeda }}</strong></td>
                </tr>
                <tr>
                  <td>Valor Inicial:</td>
                  <td><strong>R$ {{ lote.valorInicial | moeda }}</strong></td>
                </tr>
                <tr>
                  <td>Valor Meta:</td>
                  <td><strong>R$ {{ lote.valorMeta | moeda }}</strong></td>
                </tr>
                <tr>
                  <td>Valor Incremento:</td>
                  <td><strong>R$ {{ lote.valorIncremento | moeda }}</strong></td>
                </tr>
                <tr>
                  <td>Valor Remoção:</td>
                  <td><strong>R$ {{ lote.valorRemocao | moeda }}</strong></td>
                </tr>
                <tr v-if="lote.valorArremate > 0">
                  <td>Valor Arremate:</td>
                  <td class="bg-success"><strong>R$ {{ lote.valorArremate | moeda }}</strong></td>
                </tr>
                <tr>
                  <td>Taxa de Arremate:</td>
                  <td><strong>R$ {{ lote.valorTaxaArremate | moeda }}</strong></td>
                </tr>
                <tr>
                  <td>ICMS:</td>
                  <td><strong>{{ lote.icms }}%</strong></td>
                </tr>
                <tr>
                  <td>ISS:</td>
                  <td><strong>{{ lote.icms }}%</strong></td>
                </tr>
                <tr>
                  <td>Comissão:</td>
                  <td><strong>{{ lote.leilao.comissao }}%</strong></td>
                </tr>
                <tr>
                  <td>Valor Comissão:</td>
                  <td><strong>R$ {{ comissao | moeda }}</strong></td>
                </tr>
                </tbody>
              </table>

            </div>


            <div class="col-xs-12" v-if="lote.status === STATUS_RETIRADO">
              <div class="fotos-flex">
                <img width="150" src="../assets/lote-retirado.jpg" class="pull-left m-r">
              </div>
            </div>
            <div class="col-xs-12" v-else>
              <div class="m-b m-t-lg">Fotos</div>
              <div class="fotos-flex">
                <div v-for="(foto, index) in lote.fotos" :id="'ltFoto' + foto.id" class="foto">
                  <a v-if="(typeof foto.imageInfo.full !== 'undefined' && typeof foto.imageInfo.min !== 'undefined')" :href="foto.imageInfo && foto.imageInfo.full.url" target="_blank"> <img :src="foto.imageInfo && foto.imageInfo.min.url" class="img-responsive"></a>
                  <span v-if="foto.destaque" class="destaque">Destaque</span>
                  <div class="btn-actions">
                    <!--<u-button class="btn btn-xs btn-block btn-default"><i class="fa fa-photo"></i> Maximizar</u-button>-->
                    <u-button @click="defineFotoDestaque(foto.id, index)" class="btn btn-xs btn-block btn-success">
                      <span v-if="!foto.atualizandoDestaque">Tornar Destaque</span>
                      <span v-if="foto.atualizandoDestaque">Trabalhando nisso...</span>
                    </u-button>
                    <u-button @click="removeFoto(foto.id)" class="btn btn-xs btn-block btn-danger">Remover</u-button>
                  </div>
                </div>
                <div class="foto">
                  <u-button v-if="!isUploadingFoto" class="btn btn-info fileContainer hidden-print"><i
                    class="fa fa-upload m-r-sm"></i> Adicionar nova foto <input
                    @change="uploadFotoLote" accept="image/*" type="file" multiple/></u-button>
                  <div v-if="isUploadingFoto" class="text-center"><i class="fa fa-spin fa-spinner"></i> <br>Enviando
                    foto
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <popup-viewer @close="closeDadosConsulta" v-if="showDadosConsultaLote" :title="`Visualização de dados da consulta do lote #${lote.numero || ''}`">
        <DadosConsultaLoteDetro @finishSubmit="closeDadosConsulta" @cancel="closeDadosConsulta"/>
      </popup-viewer>
      <popup-viewer @close="closeFormExtratoLeilao" v-if="showFormExtratoLeilao" title="Cadastro extrato de leilão">
        <ExtratoLeilaoForm @finishSubmit="setExtratoCadastrado" @cancel="showFormExtratoLeilao = false" :extratoId="lote.extratoLeilao && lote.extratoLeilao.id || null" />
      </popup-viewer>
      <popup-viewer @close="closeFormRetirada" v-if="showFormRetirada" title="Formulário de Retirada">
        <FormularioRetirada :grvId="lote.grv && lote.grv.id" @finishSubmit="closeFormRetirada" />
      </popup-viewer>
      <popup-viewer @close="closeFormAlterarArrematante" v-if="showFormAlterarArrematante" title="Alteração de Arrematante">
        <FormularioAlterarArrematante @finishSubmit="closeFormAlterarArrematante" :lote="lote" />
      </popup-viewer>
    </div>
  </transition>
</template>
<style scoped>
  #estado-geral-title{
    display: flex;
    justify-content: flex-end;
    margin-right: 7%;
    font-size: 17px;
  }
</style>



// WEBPACK FOOTER //
// VisualizarLote.vue?45fd81d9